var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "94.316,0 0,0 0,19.977 94.316,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,68.299 0,94.316 39.71,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,161.684 0,187.701 39.71,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,19.977 256,0 161.684,0 161.684,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,187.701 256,161.684 216.29,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "161.684,174.23 161.684,256 256,256 256,236.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,94.316 256,68.299 216.29,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,236.023 0,256 94.316,256 94.316,174.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,236.023 256,216.059 172.232,161.684 196.98,161.684 256,199.995 256,187.701    216.29,161.684 256,161.684 256,148.21 148.211,148.21 148.211,256 161.684,256 161.684,174.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,148.21 0,161.684 39.71,161.684 0,187.701 0,206.602 69.197,161.684 93.945,161.684    0,222.666 0,236.023 94.316,174.23 94.316,256 107.789,256 107.789,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "107.789,0 94.316,0 94.316,81.77 0,19.977 0,41.839 80.842,94.316 56.094,94.316 0,57.904    0,68.299 39.71,94.316 0,94.316 0,107.79 107.789,107.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,107.79 256,94.316 216.29,94.316 256,68.299 256,49.157 186.432,94.316 161.684,94.316    256,33.093 256,19.977 161.684,81.77 161.684,0 148.211,0 148.211,107.79  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,148.21 256,107.79 148.211,107.79 148.211,0 107.789,0 107.789,107.79 0,107.79    0,148.21 107.789,148.21 107.789,256 148.211,256 148.211,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "69.197,161.684 0,206.602 0,222.666 93.945,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "172.232,161.684 256,216.059 256,199.995 196.98,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "80.842,94.316 0,41.839 0,57.904 56.094,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "186.432,94.316 256,49.157 256,33.093 161.684,94.316  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M395.586,441.231c-0.358,0-0.72-0.112-1.026-0.328l-10.448-7.466l-10.448,7.466   c-0.306,0.216-0.668,0.328-1.026,0.328c-0.366,0-0.728-0.112-1.039-0.336c-0.612-0.448-0.875-1.241-0.647-1.966l3.875-12.241   l-10.328-7.621c-0.612-0.457-0.866-1.241-0.634-1.966c0.237-0.724,0.905-1.216,1.668-1.224l12.841-0.103l4.06-12.181   c0.241-0.716,0.918-1.207,1.677-1.207s1.435,0.491,1.677,1.207l4.06,12.181l12.841,0.103c0.763,0.009,1.431,0.5,1.668,1.224   c0.233,0.724-0.022,1.509-0.634,1.966l-10.328,7.621l3.875,12.241c0.228,0.724-0.034,1.517-0.647,1.966   C396.315,441.119,395.948,441.231,395.586,441.231z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M384.112,404.153l4.462,13.378l14.102,0.109l-11.345,8.377l4.254,13.446l-11.473-8.2l-11.473,8.2  l4.254-13.446l-11.345-8.377l14.102-0.109L384.112,404.153 M384.112,400.622c-1.52,0-2.869,0.973-3.35,2.414l-3.663,10.984  l-11.578,0.09c-1.52,0.011-2.861,0.994-3.331,2.44c-0.47,1.445,0.038,3.029,1.261,3.932l9.314,6.878l-3.493,11.039  c-0.458,1.449,0.062,3.029,1.291,3.922c0.619,0.449,1.347,0.675,2.076,0.675c0.719,0,1.439-0.219,2.053-0.658l9.42-6.733l9.42,6.733  c0.614,0.439,1.334,0.658,2.053,0.658c0.729,0,1.457-0.225,2.076-0.675c1.229-0.893,1.749-2.473,1.291-3.922l-3.493-11.039  l9.314-6.878c1.223-0.902,1.73-2.487,1.261-3.932c-0.47-1.446-1.811-2.428-3.331-2.44l-11.578-0.09l-3.663-10.984  C386.981,401.594,385.632,400.622,384.112,400.622L384.112,400.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M395.586,267.606c-0.362,0-0.72-0.112-1.026-0.328l-10.448-7.474l-10.448,7.474  c-0.306,0.216-0.668,0.328-1.026,0.328c-0.362,0-0.728-0.112-1.039-0.336c-0.612-0.448-0.875-1.241-0.647-1.966l3.875-12.241  l-10.328-7.629c-0.612-0.457-0.866-1.25-0.634-1.966c0.237-0.724,0.909-1.216,1.668-1.224l12.841-0.095l4.06-12.181  c0.241-0.716,0.918-1.207,1.677-1.207s1.435,0.491,1.677,1.207l4.06,12.181l12.841,0.095c0.759,0.009,1.431,0.5,1.668,1.224  c0.233,0.716-0.022,1.509-0.634,1.966l-10.328,7.629l3.875,12.241c0.228,0.724-0.034,1.517-0.647,1.966  C396.315,267.494,395.948,267.606,395.586,267.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M384.112,230.526l4.462,13.378l14.102,0.109l-11.345,8.377l4.254,13.446l-11.473-8.2l-11.473,8.2  l4.254-13.446l-11.345-8.377l14.102-0.109L384.112,230.526 M384.112,226.995c-1.52,0-2.869,0.973-3.35,2.414l-3.663,10.984  l-11.578,0.09c-1.52,0.011-2.861,0.994-3.331,2.44c-0.47,1.445,0.038,3.029,1.261,3.932l9.314,6.878l-3.493,11.039  c-0.458,1.449,0.062,3.029,1.291,3.922c0.619,0.449,1.347,0.675,2.076,0.675c0.719,0,1.439-0.219,2.053-0.658l9.42-6.733l9.42,6.733  c0.614,0.439,1.334,0.658,2.053,0.658c0.729,0,1.457-0.225,2.076-0.675c1.229-0.893,1.749-2.473,1.291-3.922l-3.493-11.039  l9.314-6.878c1.223-0.902,1.73-2.487,1.261-3.932c-0.47-1.446-1.811-2.428-3.331-2.44l-11.578-0.09l-3.663-10.984  C386.981,227.967,385.632,226.995,384.112,226.995L384.112,226.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M457.379,332.744c-0.362,0-0.72-0.112-1.026-0.328l-10.448-7.474l-10.448,7.474  c-0.306,0.216-0.668,0.328-1.026,0.328c-0.362,0-0.728-0.112-1.039-0.336c-0.612-0.448-0.875-1.241-0.647-1.966l3.875-12.241  l-10.328-7.629c-0.612-0.457-0.866-1.25-0.634-1.966c0.237-0.724,0.909-1.216,1.668-1.224l12.841-0.095l4.06-12.181  c0.241-0.716,0.918-1.207,1.677-1.207s1.435,0.491,1.677,1.207l4.06,12.181l12.841,0.095c0.759,0.009,1.431,0.5,1.668,1.224  c0.233,0.716-0.022,1.509-0.634,1.966l-10.328,7.629l3.875,12.241c0.228,0.724-0.034,1.517-0.647,1.966  C458.108,332.632,457.741,332.744,457.379,332.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M445.905,295.664l4.462,13.378l14.102,0.109l-11.345,8.377l4.254,13.446l-11.473-8.2l-11.473,8.2  l4.254-13.446l-11.345-8.377l14.102-0.109L445.905,295.664 M445.905,292.133c-1.52,0-2.869,0.973-3.35,2.414l-3.663,10.984  l-11.578,0.09c-1.52,0.011-2.861,0.994-3.331,2.44c-0.47,1.445,0.038,3.029,1.261,3.932l9.314,6.878l-3.493,11.039  c-0.458,1.449,0.062,3.029,1.291,3.922c0.619,0.449,1.347,0.675,2.076,0.675c0.719,0,1.439-0.219,2.053-0.658l9.42-6.733l9.42,6.733  c0.614,0.439,1.334,0.658,2.053,0.658c0.729,0,1.457-0.225,2.076-0.675c1.229-0.893,1.749-2.473,1.291-3.922l-3.493-11.039  l9.314-6.878c1.223-0.902,1.73-2.487,1.261-3.932c-0.47-1.446-1.811-2.428-3.331-2.44l-11.578-0.09l-3.663-10.984  C448.774,293.105,447.425,292.133,445.905,292.133L445.905,292.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M333.793,350.399c-0.362,0-0.72-0.112-1.026-0.328l-10.448-7.474l-10.448,7.474  c-0.306,0.216-0.668,0.328-1.026,0.328c-0.362,0-0.728-0.112-1.039-0.336c-0.612-0.448-0.875-1.241-0.647-1.966l3.875-12.241  l-10.328-7.629c-0.612-0.457-0.866-1.25-0.634-1.966c0.237-0.724,0.909-1.216,1.668-1.224l12.841-0.095l4.06-12.181  c0.241-0.716,0.918-1.207,1.677-1.207s1.435,0.491,1.677,1.207l4.06,12.181l12.841,0.095c0.759,0.009,1.431,0.5,1.668,1.224  c0.233,0.716-0.022,1.509-0.634,1.966l-10.328,7.629l3.875,12.241c0.228,0.724-0.034,1.517-0.647,1.966  C334.521,350.287,334.155,350.399,333.793,350.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M322.319,313.319l4.462,13.378l14.102,0.109l-11.345,8.377l4.254,13.446l-11.473-8.2l-11.473,8.2  l4.254-13.446l-11.345-8.377l14.102-0.109L322.319,313.319 M322.319,309.788c-1.52,0-2.869,0.973-3.35,2.414l-3.663,10.984  l-11.578,0.09c-1.52,0.011-2.861,0.994-3.331,2.44c-0.47,1.445,0.038,3.029,1.261,3.932l9.314,6.878l-3.493,11.039  c-0.458,1.449,0.062,3.029,1.291,3.922c0.619,0.449,1.347,0.675,2.076,0.675c0.719,0,1.439-0.219,2.053-0.658l9.42-6.733l9.42,6.733  c0.614,0.439,1.334,0.658,2.053,0.658c0.729,0,1.457-0.225,2.076-0.675c1.229-0.893,1.749-2.473,1.291-3.922l-3.493-11.039  l9.314-6.878c1.223-0.902,1.73-2.487,1.261-3.932c-0.47-1.446-1.811-2.428-3.331-2.44l-11.578-0.09l-3.663-10.984  C325.188,310.76,323.838,309.788,322.319,309.788L322.319,309.788z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNz);
export default __webpack_public_path__ + "static/media/NZ.e87f36dd91524dc7fb77680739347e12.svg";
export { ForwardRef as ReactComponent };